'use strict';

agGrid.initialiseAgGridWithAngular1(angular);

angular.module('app', ['ui.router', 'agGrid', 'my-ag-grid', 'common', 'menu', 'pages']);